import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import {
    toggleCustomContainerClass,
    getAutoPlayOptions,
    updateTabStateAndArrows
} from './util';

Swiper.use([Autoplay]);

(function () {
    "use strict";

    const selectors = {
        carousel: '.csh-aem-base-carousel',
        tabsDesktop: '.csh-aem-base-carousel__tabs-desktop',
        tabsMobile: '.csh-aem-base-carousel__tabs-mobile',
        tabsNotArrow: '.swiper-slide:not(.arrow)',
        tabBtnSwiperWrapperDesktop: '.csh-aem-base-carousel__tabs-desktop .swiper-wrapper',
        tabBtnSwiperWrapperMobile: '.csh-aem-base-carousel__tabs-mobile .swiper-wrapper',
        rightArrow: '.swiper-button-right',
        leftArrow: '.swiper-button-left',
        swiper: '.csh-aem-base-carousel__content',
    };

    const MOBILE_BREAKPOINT = 768;
    const width = screen.width;
    const mediaQuery = window.matchMedia("(min-width: 1025px)");

    const handleMediaChange = (e) => {
        const tabsElement = document.querySelector(selectors.tabsDesktop);
        if (!tabsElement) return;
        toggleCustomContainerClass(tabsElement.querySelector(".swiper-wrapper"), e.matches);
    };

    const addSwiperListeners = () => {
        const carouselElement = document.querySelector(selectors.carousel);
        if (!carouselElement) return;

        const delay = carouselElement.getAttribute('data-cmp-delay');
        const autoplayEnabled = carouselElement.hasAttribute('data-cmp-autoplay');
        const autoPauseDisabled = carouselElement.hasAttribute('data-cmp-autopause-disabled');
        const autoplayOptions = getAutoPlayOptions({ delay, autoplayEnabled, autoPauseDisabled });

        const swiperWrapperDesktop = document.querySelector(selectors.tabBtnSwiperWrapperDesktop);
        const swiperWrapperMobile = document.querySelector(selectors.tabBtnSwiperWrapperMobile);

        let tabContent = new Swiper(selectors.swiper, {
            a11y: true,
            allowTouchMove: true,
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            effect: 'fade',
            autoplay: autoplayOptions,
            crossFade: true,
            on: {
                slideChange: (swiper) => {
                    const currentIndex = swiper.realIndex;
                    const isMobile = width < MOBILE_BREAKPOINT;

                    if (isMobile) {
                        updateTabStateAndArrows(swiperWrapperMobile, currentIndex, selectors);
                    } else {
                        updateTabStateAndArrows(swiperWrapperDesktop, currentIndex, selectors);
                    }
                }
            },
            breakpoints: {
                767: {
                    allowTouchMove: false,
                }
            }
        });

        document.querySelectorAll(`${selectors.tabsDesktop} ${selectors.tabsNotArrow}, ${selectors.tabsMobile} ${selectors.tabsNotArrow}`).forEach(swiper => {
            swiper.addEventListener('click', (event) => {
                const index = event.target.getAttribute('data-attr-index');
                tabContent.slideTo(index - 1);
            });
        });

        document.querySelector(selectors.rightArrow)?.addEventListener('click', () => {tabContent.slideNext()});
        document.querySelector(selectors.leftArrow)?.addEventListener('click', () => {tabContent.slidePrev()});
    };

    const onDocumentReady = () => {
        addSwiperListeners();
        handleMediaChange(mediaQuery);
        mediaQuery.addEventListener('change', handleMediaChange);
    };

    if (document.readyState !== "loading") {
        onDocumentReady();
    } else {
        document.addEventListener("DOMContentLoaded", onDocumentReady);
    }
})();